export default function Button({ children, size, customSize, color, ...buttonProps }) {
  return (
    <button type='button' {...buttonProps}>
      {children}

      <style jsx>{`
        button {
          transition: opacity 0.2s;
          color: var(--primary-button-color);
          font-weight: 700;
        }
      `}</style>

      <style jsx>{`
        button {
          min-width: ${customSize ? customSize : size === 'sm' ? 'auto' : '16rem'};
          padding: ${size === 'sm' ? '0 2.8rem' : '0 4.2rem'};
          height: ${size === 'sm' ? 2.6 : size === 'lg' ? 5 : 4.2}rem;
          border-radius: ${size === 'sm' ? 1.3 : size === 'lg' ? 2.5 : 2.1}rem;
          font-size: ${size === 'sm' ? 1.2 : size === 'lg' ? 2.2 : 1.8}rem;
          background: ${color === 'secondary'
            ? 'var(--secondary-button-bg)'
            : color === 'alert'
            ? 'var(--alert-color)'
            : color === 'success'
            ? 'var(--success-color)'
            : color === 'membership'
            ? 'rgb(21,42,70)'
            : color === 'UA'
            ? 'rgb(255,69,9)'
            : 'var(--primary-button-bg)'};
        }

        @media (max-width: 1024px) {
          button {
            min-width: unset;
            padding: ${size === 'sm' ? '0 2.8rem' : '0 3rem'};
            height: ${size === 'sm' ? 2.6 : 3.5}rem;
            border-radius: ${size === 'sm' ? 1.3 : 1.8}rem;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </button>
  )
}
